import React, { useContext } from 'react';
import { LanguageContext } from '../App';
import Layout from './Layout';

const Dashboard = () => {
  const { t, dashboardStats, tasks } = useContext(LanguageContext);

  // Get recent tasks (last 5)
  const recentTasks = tasks.slice(0, 5);

  return (
    <Layout>
      <div className="fade-in">
        {/* Page Header */}
        <div className="mb-4">
          <h1 className="text-2xl font-bold text-gray-900 mb-2">
            {t('dashboard')}
          </h1>
          <p className="text-gray-600">
            مرحباً محمد المشولي - نظرة عامة على مهامك وإنتاجيتك
          </p>
        </div>

        {/* Stats Grid */}
        <div className="stats-grid">
          <div className="stats-card stats-card-total">
            <div className="stats-header">
              <div className="stats-title">{t('totalTasks')}</div>
              <div className="stats-icon">📋</div>
            </div>
            <div className="stats-number">{dashboardStats.total_tasks}</div>
            <div className="stats-label">إجمالي المهام المسجلة</div>
          </div>

          <div className="stats-card stats-card-completed">
            <div className="stats-header">
              <div className="stats-title">{t('completedTasks')}</div>
              <div className="stats-icon">✅</div>
            </div>
            <div className="stats-number">{dashboardStats.completed_tasks}</div>
            <div className="stats-label">مهام مكتملة بنجاح</div>
          </div>

          <div className="stats-card stats-card-pending">
            <div className="stats-header">
              <div className="stats-title">{t('pendingTasks')}</div>
              <div className="stats-icon">⏳</div>
            </div>
            <div className="stats-number">{dashboardStats.pending_tasks}</div>
            <div className="stats-label">مهام في الانتظار</div>
          </div>

          <div className="stats-card stats-card-overdue">
            <div className="stats-header">
              <div className="stats-title">{t('overdueTasks')}</div>
              <div className="stats-icon">⚠️</div>
            </div>
            <div className="stats-number">{dashboardStats.overdue_tasks}</div>
            <div className="stats-label">مهام متأخرة تحتاج متابعة</div>
          </div>

          <div className="stats-card stats-card-today">
            <div className="stats-header">
              <div className="stats-title">{t('todayTasks')}</div>
              <div className="stats-icon">📅</div>
            </div>
            <div className="stats-number">{dashboardStats.today_tasks}</div>
            <div className="stats-label">مهام مجدولة لليوم</div>
          </div>

          <div className="stats-card stats-card-week">
            <div className="stats-header">
              <div className="stats-title">{t('weekTasks')}</div>
              <div className="stats-icon">📊</div>
            </div>
            <div className="stats-number">{dashboardStats.this_week_tasks}</div>
            <div className="stats-label">مهام هذا الأسبوع</div>
          </div>
        </div>

        {/* Recent Tasks */}
        <div className="card">
          <div className="card-header">
            <h2 className="card-title">المهام الحديثة</h2>
            <p className="card-subtitle">آخر المهام المضافة إلى النظام</p>
          </div>
          <div className="card-body">
            {recentTasks.length === 0 ? (
              <div className="text-center py-8">
                <div className="text-6xl mb-4">📝</div>
                <h3 className="text-xl font-semibold mb-2">لا توجد مهام حالياً</h3>
                <p className="text-gray-600 mb-4">ابدأ بإضافة مهامك اليومية لتنظيم عملك</p>
                <a href="/tasks" className="btn btn-primary">
                  إضافة مهمة جديدة
                </a>
              </div>
            ) : (
              <div className="task-list">
                {recentTasks.map((task) => (
                  <div key={task.id} className="task-item">
                    <div className="task-header">
                      <div>
                        <h3 className="task-title">{task.title}</h3>
                        {task.description && (
                          <p className="task-description">{task.description}</p>
                        )}
                      </div>
                    </div>
                    <div className="task-meta">
                      <span className="task-badge badge-category">
                        {t(task.category)}
                      </span>
                      <span className={`task-badge badge-priority-${task.priority}`}>
                        {t(task.priority)}
                      </span>
                      <span className={`task-badge badge-status-${task.status}`}>
                        {t(task.status)}
                      </span>
                      {task.due_date && (
                        <span className="text-sm text-gray-500">
                          📅 {new Date(task.due_date).toLocaleDateString('ar-SA')}
                        </span>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>

        {/* Quick Actions */}
        <div className="mt-6 flex gap-4 justify-center">
          <a href="/tasks" className="btn btn-primary">
            إدارة المهام
          </a>
          <a href="/calendar" className="btn btn-secondary">
            عرض التقويم
          </a>
        </div>
      </div>
    </Layout>
  );
};

export default Dashboard;